import { URL_QUERY_STRING } from "./storage-keys";

export const getItem = (key: string) => {
  return localStorage.getItem(key);
};

export const setItem = (key: string, value: string): void => {
  localStorage.setItem(key, value);
};

export const removeItem = (key: string): void => {
  localStorage.removeItem(key);
};

export const getSessionItem = (key: string) => {
  return sessionStorage.getItem(key);
};

export const setSessionItem = (key: string, value: string): void => {
  sessionStorage.setItem(key, value);
};

export const removeSessionItem = (key: string): void => {
  sessionStorage.removeItem(key);
};

export const getSiteCode = () => {
  const query = getItem(URL_QUERY_STRING);
  const url = new URLSearchParams(query ? query : '');
  const queryObject = Object.fromEntries(url);
  const currentSiteCode = new URLSearchParams(window.location.search).get('site-code');
  const siteCode = currentSiteCode || queryObject['site-code'] || 'vn-profile';
  return siteCode;
};
